import axios from 'axios'

const url = process.env.REACT_APP_URL

export async function updateThreshold(threshold: number) {
  console.log(threshold)
  try {
    const res = await axios.post(url + "/threshold/updateThreshold", {
      threshold: threshold
    })
    console.log(res)
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getThreshold() {
  try {
    const res = await axios.get(url + '/threshold/getThreshold', {})
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}